const aboutUs = () => import('@/pages/aboutUs/aboutUs.vue');

export default [{
  path: '/aboutUs',
  name: 'aboutUs',
  meta: {
    isLogin: false
  },
  component: aboutUs
}, ]